import React from 'react';
import { motion } from 'framer-motion';
import { Search, Map, FileText, MessageSquare, DollarSign } from 'lucide-react';
const assets = [{
  num: '01',
  title: 'The Outcome Asset Audit',
  desc: "How to translate your past work into 'C-Suite Value Speak.'",
  icon: Search
}, {
  num: '02',
  title: 'The Bleeding Neck Matrix',
  desc: 'How to find the 20 companies that need you today.',
  icon: Map
}, {
  num: '03',
  title: 'The One-Page Proposal Template',
  desc: 'The document that replaces your resume and closes deals.',
  icon: FileText
}, {
  num: '04',
  title: 'The Stealth Outreach Scripts',
  desc: 'Exactly what to say to VPs to get a 50% response rate.',
  icon: MessageSquare
}, {
  num: '05',
  title: 'The 3-Tier Pricing Framework',
  desc: 'How to structure retainers starting at $5,000/month.',
  icon: DollarSign
}];
export function WhatYouGetSection() {
  return <section className="py-24 bg-zinc-900 border-t border-zinc-800" data-id="element-158">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-159">
        <div className="mb-16" data-id="element-160">
          <h2 className="font-display text-4xl md:text-5xl text-zinc-100" data-id="element-161">
            5 ASSETS INSIDE THE <span className="text-teal-500" data-id="element-162">PIVOT MAP</span>
          </h2>
        </div>

        <div className="flex flex-col gap-4" data-id="element-163">
          {assets.map((asset, index) => <motion.div key={asset.num} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className="bg-zinc-950 border border-zinc-800 border-l-4 border-l-teal-500 p-6 md:p-8 flex items-center gap-6 group hover:bg-zinc-900/80 transition-colors" data-id="element-164">
              <div className="hidden sm:block font-display text-5xl text-zinc-800 group-hover:text-zinc-700 transition-colors" data-id="element-165">
                {asset.num}
              </div>
              <div className="w-12 h-12 rounded-full bg-teal-950 flex items-center justify-center shrink-0" data-id="element-166">
                <asset.icon className="w-6 h-6 text-teal-500" data-id="element-167" />
              </div>
              <div data-id="element-168">
                <h3 className="text-xl font-bold text-zinc-100 mb-1" data-id="element-169">
                  {asset.title}
                </h3>
                <p className="text-zinc-400" data-id="element-170">{asset.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}